module.exports = __webpack_public_path__ + "static/img/banner.96034940.jpg";